/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFeedbackFormField } from './APIFeedbackFormField';
import {
    APIFeedbackFormFieldFromJSON,
    APIFeedbackFormFieldFromJSONTyped,
    APIFeedbackFormFieldToJSON,
} from './APIFeedbackFormField';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIFeedbackForm
 */
export interface APIFeedbackForm {
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackForm
     */
    readonly self: string;
    /**
     * 
     * @type {Array<APIFeedbackFormField>}
     * @memberof APIFeedbackForm
     */
    formJson: Array<APIFeedbackFormField>;
    /**
     * 
     * @type {Date}
     * @memberof APIFeedbackForm
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIFeedbackForm
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackForm
     */
    formTitle: string;
}

/**
 * Check if a given object implements the APIFeedbackForm interface.
 */
export function instanceOfAPIFeedbackForm(value: object): value is APIFeedbackForm {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('formJson' in value) || value['formJson'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('formTitle' in value) || value['formTitle'] === undefined) return false;
    return true;
}

export function APIFeedbackFormFromJSON(json: any): APIFeedbackForm {
    return APIFeedbackFormFromJSONTyped(json, false);
}

export function APIFeedbackFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFeedbackForm {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'formJson': ((json['form_json'] as Array<any>).map(APIFeedbackFormFieldFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'formTitle': json['form_title'],
    };
}

export function APIFeedbackFormToJSON(value?: Omit<APIFeedbackForm, 'self'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'form_json': ((value['formJson'] as Array<any>).map(APIFeedbackFormFieldToJSON)),
        'form_title': value['formTitle'],
    };
}

